import { createVariadicExpression } from '../expressions';
import { operatorDefinitions } from '../operators';

export const parseBuilderQuery = (
  originalBuilderQuery: Record<string, unknown>,
): unknown => {
  if (!originalBuilderQuery || !Array.isArray(originalBuilderQuery?.operands)) {
    return originalBuilderQuery;
  }

  const builderQuery = JSON.parse(JSON.stringify(originalBuilderQuery));
  const expandedTree = [];

  // check every 'row' of the builderQuery for formatting issues
  for (let i = 0, len = builderQuery.operands.length; i < len; i += 1) {
    const originalRow = builderQuery.operands[i];
    let newRow = { ...originalRow };

    // if a top level row is 'variadic', we assume it was originally a binary row but with
    // a variadic right hand side
    if (
      originalRow.expressionType === 'variadic' &&
      originalRow.operands[0]?.expressionType === 'binary'
    ) {
      // take all of the operands, copy the first one as the 'base' for all of
      // the rows to merge together into
      const rows = [...originalRow.operands];
      newRow = { ...rows[0] };

      if (rows.length > 1) {
        newRow.right = createVariadicExpression(
          operatorDefinitions.or,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ...rows.map((r) => r.right),
        );
      }
    }

    expandedTree.push(newRow);
  }

  const newTree = [];

  // check expanded rows for formatting issues
  for (let i = 0, len = expandedTree.length; i < len; i += 1) {
    const row = { ...expandedTree[i] };

    // correctly format source information
    switch (row.expressionType) {
      case 'binary':
        row.left = {
          ...row.left,
          fieldTarget: row.left.source,
          source: row.left.sourceName,
        };
        delete row.left.sourceName;
        break;
      case 'unary':
        row.operands[0] = {
          ...row.operands[0],
          fieldTarget: row.operands[0].source,
          source: row.operands[0].sourceName,
        };
        delete row.operands[0].sourceName;
        break;
      default:
        break;
    }

    // correctly format binary relativeDates
    if (row.expressionType === 'binary' && row.right?.type === 'relativeDate') {
      const currentDateValue = row.right.value;
      const dateDirection = currentDateValue > 0 ? 'from now' : 'ago';

      row.right = {
        ...row.right,
        direction: dateDirection,
        value: Math.abs(currentDateValue).toString(),
      };
    }

    newTree.push(row);
  }

  return { ...originalBuilderQuery, operands: [...newTree] };
};
